const manageuser = {
    currentsite: "Current site",
    whohasaccess: "Who has access",
    thisisyourprivateaccount:"This is your private account",
    youllneedto:"You'll need to create - switch to - or get invited to site accounts so that you can get access to events, get the ability to charge ads and more.",
    createsite: "Create site",
    youraccounts: "Your accounts",
    welcome: "Welcome",
    logout: "Log out",
    upcoming: "Upcoming",
    admarket: "Admarket",
    createevent: "Create event",
    userdashboard: "User dashboard",
    importevents: "Import events",
    letsgetstarted: "Let's get started",
    startingout: "To do that you need to create a full account. That account will be able to get access to events, book ads and more. You can have access to more than one full account (think multiple bands, venues or websites) and you can switch between them easily.",
    nameofaccount: "Name of account",
    nameofbusiness: "Company name",
    kennitala: "ID number",
    emailforinvoicing: "Email for invoicing",
    podepartment: "PO / department / project",
    urltopost: "URL to post invoices (if any)",
    electronicinvoicing: "Electronic invoicing",
    youcanhaveaccess: "You can have access to more than one full account, which is useful if you need separate invoices by departments.",
    createbutton: "Create",
    createinfo: "If you want to charge ads to this account and get an invoice, please fill in the fields below. You can also add this later.",
    hello: "Hello",
    createuser: "Create user",
    createanaccount: "Create an account",
    createaccountinfo: "Create an account for yourself. Then you can join or create full accounts to manage events or advertising.",
    yourname: "Your name",
    email: "Your Email",
    password: "Password",
    alreadyamember: "Already a member?",
    login: "Log in",
    showconnector: "Connect",
    showconnectorinfo: "Select artist or venue you want to connect",
    showconnectorinfodetail: "Connecting data from an artist or venue helps to manage events and advertising.",
    setpaymentinfo: "Set payment information",
    showpaymentinfo: "Show payment info.",
    savebutton: "Save",

    canedit: "Access to create and edit events",
    caneditinfo: "Understandably we cannot let just anyone do that. So we'll need to check that you are allowed to do this.",
    canedityes: "You have access",
    caneditno: "You do not have access",
    commentplaceholder: "Reason for requesting access",
    imagecollection: "Image collection",
};
export default manageuser;
